import { defineStore } from 'pinia'
import { 
  fetchReadinessGuides, 
  fetchGuideContent, 
  fetchActivities 
} from '../helpers/api'
import { useAuthStore } from './auth.store';


export const useReadinessStore = defineStore('readiness', {
  state: () => ({
    readinessAreas: {},
    readinessGuides: {},
    currentGuideId: null,
    guideContent:{},
    activities: {},
    filterByGuideIds: [],
    filterByAreaIds: [],
    filterByChildIds: [],
  }),
  actions: {
    async fetchReadinessGuides () {
      const response = await fetchReadinessGuides()
      this.readinessGuides = response.data.readiness_guides.reduce((acc, readinessGuide) => {
        acc[readinessGuide.id] = {...readinessGuide.attributes, id: readinessGuide.id}
        return acc
      }, {})
    },
    async fetchCurrentGuide (id) {
      // flatten the content so the properties are flat with the milestones and activities
      // fetch the guide
      const response = await fetchGuideContent(id)
      const guide = response.status.data.readiness_guide
      this.readinessGuides[guide.id] = { ...guide.attributes, id: guide.id }
    },
    async fetchActivities () {
      const response = await fetchActivities()
      this.readinessAreas = response.status.data.readiness_areas.reduce((acc, readinessArea) => {
        acc[readinessArea.id] = {...readinessArea.attributes, id: readinessArea.id}
        return acc
      }, {})
      this.activities = response.status.data.readiness_activities.reduce((acc, activity) => {
        acc[activity.id] = {...activity.attributes, id: activity.id}
        return acc
      }, {})
    },
    toggleChildFilter (childId) {
      if (this.filterByChildIds.includes(childId)) {
        this.filterByChildIds = this.filterByChildIds.filter(id => id !== childId)
      } else {
        this.filterByChildIds.push(childId)
      }
    },
    toggleGuideFilter (guideId) {
      if (this.filterByGuideIds.includes(guideId)) {
        this.filterByGuideIds = this.filterByGuideIds.filter(id => id !== guideId)
      } else {
        this.filterByGuideIds.push(guideId)
      }
    },
    toggleAreaFilter (areaId) {
      if (this.filterByAreaIds.includes(areaId)) {
        this.filterByAreaIds = this.filterByAreaIds.filter(id => id !== areaId)
      } else {
        this.filterByAreaIds.push(areaId)
      }
    },
    clearChildFilters () {
      this.filterByChildIds = []
    },
  },
  getters: {
    sortedReadinessGuides: (state) => {
      return Object.entries(state.readinessGuides)
      .sort((a, b) => b[1].months_marker - a[1].months_marker)
      .map(([key, value]) => ({ id: key, ...value }))
    },
    currentGuideContent: (state) => {
      return (id) => {
        const currentGuide = state.readinessGuides[id]
        // return [currentGuide['socio-emotional'], currentGuide.motor, currentGuide.language, currentGuide.cognitive]
        const ret = Object.values(currentGuide.readiness_map).map(readinessArea => {
          return {...readinessArea, ...readinessArea.readiness_area.attributes}
        })
        return ret
      }
    },
    sortedActivities: (state) => {
      let activities = Object.values(state.activities)
      if (state.filterByGuideIds.length > 0) {
        activities = activities.filter(activity => {
          return activity.filter_ids.guide_ids.some(id => state.filterByGuideIds.includes(id.toString())) 
        })
      }
      if (state.filterByAreaIds.length > 0) {
        activities = activities.filter(activity => {
          return activity.filter_ids.area_ids.some(id => state.filterByAreaIds.includes(id.toString())) 
        })
      }
      if (state.filterByChildIds.length > 0) {
        const authStore = useAuthStore()
        const filteredChildren = authStore.sortedChildren.filter(child => state.filterByChildIds.includes(child.id))
        const mappedChildMilestoneIds = filteredChildren.map(child => {
          return child.current_readiness_report_card.incomplete_milestones.map(milestone => milestone.id)
        }).flat()
        activities = activities.filter(activity => {
          return activity.filter_ids.milestone_ids.some(id => mappedChildMilestoneIds.includes(id)) 
        })
      }
      return activities
    }
  }
});